import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from '@components/App';
import './__styles/index.scss';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
	<BrowserRouter>
		<App />
	</BrowserRouter>
);
